import { intersect, partial, struct, union } from 'io-ts/Decoder';

import { Id as CustomerId } from '../../../customer/Id';
import { Id as JobId } from '../../../job/Id';
import { Id as OrganizationId } from '../../../organization/Id';

export const ParamsByOrganization = intersect(
	struct({
		organizationId: OrganizationId,
	})
)(
	partial({
		customerId: CustomerId,
	})
);

export const ParamsByJob = struct({
	jobId: JobId,
});

export const Params = union(ParamsByOrganization, ParamsByJob);
